import api from '../api';

async function fetchSpecialties(params) {
    const response = await api.get('specialties', { params });
    return response.data;
}

export { fetchSpecialties };
